import { ArrowLeft } from "lucide-react";

function BackButton({ children, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`text-sm px-4 py-2 border border-gray-400 rounded-md back_link flex items-center gap-2`}
    >
      <ArrowLeft size={16} />
      {children}
    </button>
  );
}

export default BackButton;
